import { MaterialCommunityIcons } from "@expo/vector-icons";
import { HStack, Icon, Image, Link, Text } from "native-base";
import React from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import { useAppSelector } from "@/hooks/application/store";

import HeaderAccountButton from "../HeaderAccountButton";
import HearderCartButton from "../HearderCartButton";

type SimpleWebHeaderProps = {
  showCartButton?: boolean;
  showAccountButton?: boolean;
};

const SimpleWebHeader = ({
  showAccountButton = true,
  showCartButton = true,
}: SimpleWebHeaderProps) => {
  const { logged } = useAppSelector((store) => store.auth);
  return (
    <HStack w="full" bgColor="white.50" justifyContent="center" shadow="4" zIndex={9999}>
      <HStack w="full" px="1/4" justifyContent="space-between" py={2}>
        <HStack alignItems="center" space="8">
          <Link href="/">
            <Image source={IfeiraLogo} resizeMode="contain" w="120px" h="60px" alt="ifeira logo" />
          </Link>
          <Link href="/">
            <Icon as={<MaterialCommunityIcons name="home" />} size="lg" color="primary.600" />
            <Text color="primary.600" fontSize="md">
              Início
            </Text>
          </Link>
          <Link href="/busca">
            <Icon as={<MaterialCommunityIcons name="magnify" />} size="lg" color="primary.600" />
            <Text color="primary.600" fontSize="md">
              Buscar
            </Text>
          </Link>
        </HStack>
        {logged && (
          <HStack alignItems="center">
            {showCartButton && <HearderCartButton />}
            {showAccountButton && <HeaderAccountButton />}
          </HStack>
        )}
      </HStack>
    </HStack>
  );
};

export default SimpleWebHeader;
